import CreateUserQrCode from "./CreateUserQrCode";
import useAuth from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { ModalShell } from "../../../atoms/ModalShell";
import { Copy } from "../../../atoms/Copy";

const AddUserByShareQrCodeModal = ({
  show,
  onHide,
  size,
  className,
  onBackClick,
}: {
  show: boolean;
  onHide: () => void;
  size?: "lg" | "sm" | "xl" | "2xl";
  className?: string | undefined;
  onBackClick: () => void;
}) => {
  const [t] = useTranslation();
  const { user } = useAuth();

  const code = `user/${user.entity_identification}/registration`;

  const handleCloseModal = () => {
    onHide();
  };

  return (
    <ModalShell
      show={show}
      onClose={handleCloseModal}
      size={size}
      className={className}
      title={t("dashboard.addUserByShare.title")}
      subtitle={t("dashboard.addUserByShare.text-02")}
    >
      <div className="flex flex-col gap-6 items-center justify-center">
        <div className="w-full max-w-[291px] h-10 pl-4 pr-3 py-2.5 bg-gray-100 rounded-md justify-start items-center gap-3 inline-flex">
          <div
            title={`${process.env.REACT_APP_HOST_URL}/${code}`}
            className="text-gray-700 text-sm leading-tight truncate"
          >
            {`${process.env.REACT_APP_HOST_URL}/${code}`}
          </div>
          <div className="text-gray-200 text-sm leading-tight shrink-0">|</div>
          <Copy
            target={`${process.env.REACT_APP_HOST_URL}/${code}`}
            iconOnly
            title={t("common.copy") as string}
            className="cursor-pointer"
            iconClassName="text-base"
          />
        </div>

        <CreateUserQrCode />
      </div>
    </ModalShell>
  );
};

export default AddUserByShareQrCodeModal;
